export abstract class AbstractTracker<
  TData extends Record<string, unknown> = Record<string, unknown>,
> {
  protected data: TData = Object.create(null);

  constructor(private name: string) {
    this.name = name;
    this.track = this.track.bind(this);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get eventName() {
    return this.name;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get eventData() {
    return this.data;
  }

  abstract track(...args: any[]): void;

  drop(): void {
    this.data = Object.create(null);
  }
}
